// extracted by mini-css-extract-plugin
export default {"root":"NjLF2Labfb","title":"H_vFmnpM90"};